import { buildTaxonomyPath } from "../../../utils/functions";

export function buildDescription(action, module, formValues, error = null) {
  const taxonomyPath = buildTaxonomyPath(formValues);
  const sector = formValues.sector || "";
  const country = formValues.country ? ` ${formValues.country}` : "";
  const taxonomyPart = taxonomyPath ? ` ${taxonomyPath}` : "";

  const region = formValues.region || "not provided";
  const equipment = formValues.equipment || "not provided";
  const requirements = formValues.requirements
    ? `"${formValues.requirements}"`
    : "not provided";
  const context = formValues.context
    ? `"${formValues.context}"`
    : "not provided";

  if (action === "Generate Insight") {
    if (error)
      return `${action}: FAILED in ${module} with taxonomy: ${taxonomyPart}. Error: ${error}`;
    return [
      `${action}: User used ${module}`,
      `Sector: ${sector}`,
      `Taxonomy: ${taxonomyPart}`,
      `Country: ${country}`,
      `Context: ${context}`,
    ].join("\n");
  }

  if (action === "Export PowerPoint") {
    if (error) return `${action}: FAILED in ${module}. Error: ${error}`;
    return "Export PowerPoint: User exported insights to PowerPoint";
  }

  if (action === "Rerun From User History") {
    if (error) return `${action}: FAILED in ${module}. Error: ${error}`;
    return [
      `${action}: User used ${module}`,
      `Sector: ${sector}`,
      `Taxonomy: ${taxonomyPart}`,
      `Country: ${country}`,
    ].join("\n");
  }

  if (action === "Delete User History") {
    if (error) return `${action}: FAILED in ${module}. Error: ${error}`;
    return [
      `${action}: User deleted entry:`,
      `Sector: ${sector}`,
      `Taxonomy: ${taxonomyPart}`,
      `Country: ${country}`,
    ].join("\n");
  }

  if (action === "Generate Supplier Finder") {
    if (error)
      return `${action}: FAILED in ${module} with taxonomy: ${taxonomyPart}. Error: ${error}`;
    return [
      `${action}: User used ${module}`,
      `Sector: ${sector}`,
      `Taxonomy: ${taxonomyPart}`,
      `Country: ${country}`,
      `Region: ${region}`,
      `Equipment: ${equipment}`,
      `Requirements: ${requirements}`,
      `Context: ${context}`,
    ].join("\n");
  }

  if (action === "Process Iterator Test") {
    if (error) return `${action}: FAILED in ${module}. Error: ${error}`;
    const promptType = formValues.multiPrompt
      ? "Multi Prompt"
      : "Single Prompt";
    return `${action}: User used ${module} (${promptType})`;
  }

  if (action === "Process Iterator") {
    if (error) return `${action}: FAILED in ${module}. Error: ${error}`;
    const promptType = formValues.multiPrompt
      ? "Multi Prompt"
      : "Single Prompt";
    return `${action}: User used ${module} (${promptType})`;
  }

  if (action === "Process Translator" || action === "Process Redaction") {
    if (error) return `${action}: FAILED in ${module}. Error: ${error}`;
    return `${action}: User used ${module}`;
  }

  if (action === "Download Test File") {
    const fileName = formValues.fileName || "unknown file";
    const downloadFileName =
      formValues.downloadFileName || "processed test file";
    return `${action}: User uploaded "${fileName}" and downloaded "${downloadFileName}"`;
  }

  if (action === "Download Processed File") {
    const fileName = formValues.fileName || "unknown file";
    const downloadFileName = formValues.downloadFileName || "processed file";
    return `${action}: User uploaded "${fileName}" and downloaded "${downloadFileName}"`;
  }

  return `${action}: User used ${module}`;
}